import React from 'react';

// Z-index layering constants - SINGLE SOURCE OF TRUTH
export const Z_INDEX = {
  BASE: 0,           // L0_BASE - page background
  CONTENT: 10,       // L10_CONTENT - standardni sadržaj (filters, results, map)
  STICKY: 20,        // L20_STICKY - sticky paneli (filters sticky, map sticky)
  HEADER: 30,        // L30_HEADER - sticky search header
  DROPDOWN: 40,      // L40_DROPDOWN - autocomplete dropdown
  MODAL: 50,         // L50_MODAL - modali/bottom sheet
} as const;

// Utility classes for z-index
export const zIndexClasses = {
  base: 'z-0',
  content: 'z-[10]',
  sticky: 'z-[20]',
  header: 'z-[30]',
  dropdown: 'z-[40]',
  modal: 'z-[50]',
} as const;

// Debug mode flag (set via env or localStorage)
export const isDebugLayering = () => {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem('debug-layering') === 'true' || import.meta.env.VITE_DEBUG_LAYERING === 'true';
};

// Debug wrapper component
export const DebugLayer = ({ children, label, zIndex }) => {
  if (!isDebugLayering()) {
    // Return children as fragment
    return children;
  }
  
  return (
    <div className="relative" style={{ backgroundColor: `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255}, 0.1)` }}>
      <div className="absolute top-0 left-0 px-2 py-1 text-xs font-mono bg-black/80 text-white z-[100]">
        {label} (z-{zIndex})
      </div>
      {children}
    </div>
  );
};
